import { createRef } from 'react'
import _ from 'lodash'
import clx from 'classnames'
import { Loader } from '@vzmi/shp_shared_compo'
import styles from './SearchKeywords.css'
import safeAwait from '../../../../../lib/safeAwait'
import SPBaseModule from '../../../../lib/SPBaseModule'
import RangeSummary from '../../../Common/NewDashboard/RangeSummary/RangeSummary'
import TableAction from '../../../Common/NewDashboard/Table/TableAction/TableAction'
import KeywordsListingDialog from './KeywordsListingDialog/KeywordsListingDialog'
import Sort from '../../../Common/NewDashboard/Sort/Sort'
import Tip from './Tip/Tip'
import Table from './Table/Table'
import { SORT_OPTIONS } from './constants'
import {
  GA_CLICK_ACTION,
  getI13nModel
} from './SearchKeywords.ga'

const SEARCH_KEYWORDS_LIMIT = 5

class SearchKeywords extends SPBaseModule {
  constructor (props) {
    super(props)
    this.state = {
      sortType: SORT_OPTIONS[0].value,
      data: [],
      dateRange: []
    }
    this.dialog = createRef()
  }

  componentDidMount () {
    this.onSearch()
  }

  onSearch = () => this.loading(async () => {
    const { fetchSearchKeywords } = this.props
    const { sortType } = this.state
    const params = {
      sort: `-${sortType}`,
      // dashboard 頁面一次只顯示前 5 筆
      limit: SEARCH_KEYWORDS_LIMIT
    }

    const [reqError, resp] = await safeAwait(fetchSearchKeywords(params))
    const error = reqError || resp.error
    if (error) {
      this.setIsError(true)
      this.setIsLoading(false)
      return
    }

    const {
      searchKeywords = [],
      reportDateStart,
      reportDateEnd
    } = _.get(resp, 'payload', {})
    const isReportDateExist = reportDateStart && reportDateEnd
    this.setState({
      data: searchKeywords,
      dateRange: isReportDateExist ? [reportDateStart, reportDateEnd] : []
    })
    this.setIsSuccess(true)
  })

  onSortChange = e => {
    const { sortType } = this.state
    const newSortType = _.get(e, 'target.value', '')
    if (newSortType === sortType) {
      return
    }
    this.sendPageviewByAction({
      type: GA_CLICK_ACTION.TABLE_SORT,
      payload: newSortType
    })
    this.setState(
      () => ({ sortType: newSortType }),
      () => this.onSearch()
    )
  }

  sendPageviewByAction = (action) => {
    const i13nModel = getI13nModel(action)
    this.props.sendDashboardPageview(i13nModel)
  }

  onReadmoreClick = e => {
    this.sendPageviewByAction({
      type: GA_CLICK_ACTION.READ_MORE
    })
  }

  onListingClick = async (keyword) => this.dialog.current.loading(async () => {
    this.sendPageviewByAction({
      type: GA_CLICK_ACTION.VIEW_GD
    })
    this.dialog.current.onOpen(keyword)
  })

  render () {
    const { className } = this.props
    const {
      sortType,
      data,
      dateRange,
      isLoading,
      isError
    } = this.state
    const clz = clx(styles.SearchKeywords, {
      [className]: !!className
    })
    return (
      <div
        className={clz}
        data-role='search-keywords'
      >
        <Loader loaded={!isLoading}>
          {
            isError
              ? this.renderIOError()
              : (
                <div className={styles.tableBlock}>
                  <RangeSummary range={dateRange}>
                    （自 2026/01/13(含)起，改由 Google Analytics (GA) 提供。)
                  </RangeSummary>
                  <TableAction leftContent={<Tip />} >
                    <Sort
                      id='search-keywords'
                      options={SORT_OPTIONS}
                      sortType={sortType}
                      onChange={this.onSortChange}
                    />
                  </TableAction>
                  <Table
                    data={data}
                    readmoreProps={{
                      href: '/item/searchKeywords',
                      onClick: this.onReadmoreClick
                    }}
                    onListingClick={this.onListingClick}
                  />
                </div>
              )
          }
          <KeywordsListingDialog
            key='dialog'
            ref={this.dialog}
            fetchSpecificSearchKeywordListings={this.props.fetchSpecificSearchKeywordListings}
          />
        </Loader>
      </div>
    )
  }
}

export default SearchKeywords
